import { useCurrentGroupContext } from "hooks/useCurrentGroupContext";
import { useGetEntityDataAttributesQuery } from "store/apis/entity";
import { FieldBuilder } from "components/Entity/EntityFormEngine/FieldBuilder";
import {
  BASIC_INFORMATION_SECTION,
  CONTACT_INFORMATION,
} from "constants/onBoarding";
import classNames from "classnames";
import { useQuery } from "hooks/useQuery";
import { ToolTipIcon } from "components/icons/TooltipIcon";
import ToolTip from "components/design/toolTip";

const fullWidthFieldType = ["ADDRESS"];

export const SalesTaxEntityDetailsBase = ({ onChange }: any) => {
  const { uuid: groupId } = useCurrentGroupContext();
  const query = useQuery();
  let entityId = query.get("entity") as string;

  const { data: currentEntityDetails = [] } = useGetEntityDataAttributesQuery(
    {
      groupId: groupId!,
      entityId,
    },
    {
      skip: !groupId || !entityId,
    }
  );

  const group = useCurrentGroupContext();

  return (
    <div>
      <div className="t-grid t-grid-cols-2 t-gap-x-4 t-gap-y-3 t-border-neutral-10 t-pb-6 t-border-b t-border-0 t-border-solid">
        <div>
          <div className="t-flex t-items-center">
            <label
              className={classNames("t-text-body-sm t-text-text-30 t-m-0")}
            >
              Trade name or DBA
            </label>
            <div className="t-ml-1 t-pb-1.5">
              <ToolTip
                text={"Group Name or Doing Business As (DBA)"}
                side="right"
              >
                <span>
                  <ToolTipIcon />
                </span>
              </ToolTip>
            </div>
          </div>
          <span className="t-text-body t-text-text-100 ">{group?.name}</span>
        </div>
        {currentEntityDetails
          .filter(
            ({ section_name, is_sales_tax_onboarding_field, name }) =>
              section_name === BASIC_INFORMATION_SECTION &&
              is_sales_tax_onboarding_field &&
              name !== "principal_place_of_business"
          )
          .map((field) => {
            return (
              <div
                className={classNames({
                  "t-col-span-2": fullWidthFieldType.includes(field.type),
                })}
                key={field.uuid}
              >
                <FieldBuilder
                  field={field}
                  onChange={onChange}
                  size="regular"
                  entityIdFromProps={entityId}
                />
              </div>
            );
          })}
      </div>
      <div>
        <p className="t-text-text-60 t-text-subtitle-sm t-mt-6">
          Contact details
        </p>
        <div className="t-grid t-grid-cols-2 t-items-start t-justify-start t-gap-x-4 t-gap-y-3">
          {currentEntityDetails
            .filter(
              ({ section_name, is_sales_tax_onboarding_field, name }) =>
                (section_name === CONTACT_INFORMATION &&
                  is_sales_tax_onboarding_field) ||
                name === "principal_place_of_business"
            )
            .map((field) => {
              return (
                <div
                  className={classNames({
                    "t-col-span-2": fullWidthFieldType.includes(field.type),
                  })}
                  key={field.uuid}
                >
                  <FieldBuilder
                    field={field}
                    onChange={onChange}
                    size="regular"
                  />
                </div>
              );
            })}
        </div>
      </div>
    </div>
  );
};
